var map = {
	"./Categorias.svg": 3517,
	"./Descontos.svg": 2677,
	"./Documentos.svg": 1636,
	"./Emissaodenotas.svg": 8294,
	"./Estatisticas.svg": 3376,
	"./Faturamento.svg": 2531,
	"./Formasdepagamento.svg": 7834,
	"./Horarios.svg": 9332,
	"./Informacoesfiscais.svg": 2709,
	"./Leitordecodigos.svg": 3479,
	"./Metodosdeenvio.svg": 6116,
	"./Pedidos.svg": 1857,
	"./Perfil.svg": 9671,
	"./Perguntas.svg": 9048,
	"./Produtos.svg": 8091,
	"./Registrardevolucao.svg": 7002,
	"./Registrarpedido.svg": 3201,
	"./Todosospedidos.svg": 2176,
	"./Totens.svg": 890,
	"./Visordeproducao.svg": 9208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9101;